import { z } from 'zod/v4-mini';

import { Schema } from '@/utils/zodUtils.ts';

export type NurseNotice = {
  id: string;
  patient_id: string;
};

export const nurseNoticeSchema: Schema<NurseNotice> = z.object({
  id: z.string(),
  patient_id: z.string(),
});

export type CreateNurseNotice = {
  patient_id: string;
};

export type DeleteNurseNotice = {
  patient_id: string;
  id: string;
};

export type MitigateNurseNotice = {
  patient_id: string;
  id: string;
};
